import styles from "./styles/FollowingView.module.scss";
import FontAwesome from "../utilities/FontAwesome";
import FollowFeedPageItem from "../misc/FollowFeedPageItem";
import widgetStyles from "./styles/SchoolFeedWidget.module.scss";
import Button from "../utilities/Button";
import ApiClient from "../../backends/ApiClient";
import useSWRInfinite from "swr/infinite";

export default function FollowingView() {
  const { data, isLoading, setSize, isValidating, mutate } = useSWRInfinite(
    (pageIndex) => {
      return JSON.stringify({
        page: pageIndex,
        key: "get-following",
      });
    },
    async (key) => {
      const parsedKey = JSON.parse(key);
      const client = await ApiClient();
      const result = await client.GET("/organizations/", {
        params: {
          query: {
            following: true,
            page_size: 20,
            ordering: "title",
            deleted: false,
            fields:
              "id,url,title,type,path,is_following,title_organization,title_organization.title",
            expand: "schoolfeed_items_count,title_organization,url",
            page: parsedKey.page + 1,
            published: 1,
          },
        },
      });

      return {
        organizations: result.data as unknown as OrganizationTypeOrganization[],
        total: result.meta.total,
      };
    },
    {
      revalidateIfStale: false,
      revalidateOnFocus: false,
      revalidateOnMount: true,
    },
  );

  const organizations =
    data?.reduce((acc, curr) => [...acc, ...curr.organizations], []) || [];
  const total = data?.[0].total ?? 0;

  return (
    <div id="following-grid-container" className={styles.followingContainer}>
      <div>
        {isLoading || (
          <div className={styles.title}>
            <FontAwesome prefix={"fas"} name={"fa-star"} />
            <span style={{ color: "grey", margin: "0px 20px 0px 5px" }}>
              Subscriptions{" "}
            </span>{" "}
            {total}
          </div>
        )}
      </div>
      <div className="sb-content-width" style={{ textAlign: "center" }}>
        {isLoading ? (
          <div style={{ marginTop: "25%", color: "black" }}>
            <FontAwesome
              prefix={"fas"}
              name={"fa-spinner"}
              spin={isLoading}
              size={"2x"}
            />
          </div>
        ) : (
          <>
            {total === 0 && (
              <div style={{ backgroundColor: "white", padding: "25px" }}>
                <h3 style={{ color: "black" }}>
                  Please follow organizations in order to fill your SchoolFeed.
                  Click the <FontAwesome name="fa-star" prefix={"far"} />
                  icon in the upper, right corner of a classroom, department,
                  group, or section to follow it.
                </h3>
              </div>
            )}
          </>
        )}
      </div>
      {organizations.map((organization) => {
        return (
          <FollowFeedPageItem
            key={organization.id}
            organization={organization}
            updateFollowersCount={mutate}
            url={organization.url}
            isFollowing={true}
          />
        );
      })}
      {!isLoading && organizations.length < total && (
        <div
          style={{ marginTop: "2rem" }}
          className={widgetStyles.fetchMoreContainer}
        >
          <Button disabled={isValidating} onClick={() => setSize((v) => v + 1)}>
            {isValidating ? (
              <FontAwesome name={"fas fa-spinner"} spin />
            ) : (
              "View More"
            )}
          </Button>
        </div>
      )}
    </div>
  );
}
